export default "__VITE_ASSET__1qmNDJ47__"